import { QueryClient } from "react-query";

const STALE_TIME = 60 * 1000;
const FALLBACK_REFETCH_INTERVAL = 5 * 60 * 1000;

export const REALTIME_QUERY_KEYS = {
	viaje: ["viaje", "viajes", "solicitud", "todos-count", "finalizado-count", "en_curso-count", "programado-count", "home"],
	viaje_portuario: ["viajes-portuarios-transportista", "viaje-portuario-transportista", "solicitudes-portuarias", "home"],
	pago: ["pago", "pagos", "home"],
	seguro: ["seguro", "seguros-todos-count", "seguros-siniestros-count", "transportista", "home"],
	siniestro: ["siniestro", "seguro", "seguros-todos-count", "seguros-siniestros-count"],
	cliente: ["transportista", "home"],
	usuario: ["usuario", "transportista"],
	empresa: [],
	rfc: [],
	transportista: ["transportista", "home"],
	conductor: ["conductor", "home"],
	unidad: ["Unidad", "home"],
	equipo: ["equipo", "home"],
	carta_porte: ["viaje", "viajes", "viaje-portuario-transportista"],
	precio_saas: [],
};

const FALLBACK_QUERY_KEYS = [
	"home",
	"viaje",
	"viajes",
	"solicitud",
	"solicitudes-portuarias",
	"viajes-portuarios-transportista",
	"pago",
	"pagos",
	"seguro",
	"siniestro",
	"conductor",
	"Unidad",
	"equipo",
];

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: STALE_TIME,
			refetchOnWindowFocus: true,
			refetchOnReconnect: true,
		},
	},
});

FALLBACK_QUERY_KEYS.forEach(queryKey => {
	queryClient.setQueryDefaults(queryKey, {
		refetchInterval: FALLBACK_REFETCH_INTERVAL,
		refetchIntervalInBackground: false,
	});
});

export function getRealtimeQueryKeys(entity) {
	return REALTIME_QUERY_KEYS[entity] || [];
}

export function invalidateRealtimeEntity(entity, filters) {
	getRealtimeQueryKeys(entity).forEach(queryKey => {
		if(filters) queryClient.invalidateQueries(queryKey, filters);
		else queryClient.invalidateQueries(queryKey);
	});
}

export function reconcileRealtimeQueries() {
	const queryKeys = new Set(Object.values(REALTIME_QUERY_KEYS).flat());
	queryKeys.forEach(queryKey => queryClient.invalidateQueries(queryKey));
}

export default queryClient;
